module.exports = __webpack_public_path__ + "img/icon_delivery.14cc304e.svg";